import { useRouter } from 'next/router'
import React from 'react'

import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'

import { DATE_FORMAT_OPTIONS } from '@/lib/constants'
import { DeviceStatus, Estimate } from '@/lib/types'
import { formatCurrency } from '@/lib/utils'

import { useHostingMessages } from '@/hooks/useHostingMessage'

import RowSkeleton from '@/components/skeletons/RowSkeleton'

const DeviceHostingPrice = ({
  currency,
  isLoading,
  className,
  preorderFor,
  dailyEstimate,
  monthlyEstimate,
  storagePricePerDay,
  hasEarnings = true,
  status
}: {
  currency: string
  monthlyEstimate: Estimate | undefined
  dailyEstimate: Estimate | undefined
  hasEarnings?: boolean
  isLoading?: boolean
  className?: string
  storagePricePerDay?: number
  status?: DeviceStatus
  preorderFor?: Date | null
}) => {
  const { formatDate } = useIntl()
  const isDeviceOffline = status === 'offline'
  const { incomeMessage, hostingMessage, getPreorderMessage } =
    useHostingMessages({
      currency,
      dailyEstimate,
      monthlyEstimate
    })

  return (
    <div className={clsx('space-y-1', className)}>
      {isLoading && (
        <div className="flex flex-col gap-1">
          <RowSkeleton className="h-[18px] w-52" />
          <RowSkeleton className="h-[18px] w-52" />
        </div>
      )}
      {hasEarnings && !isLoading && (
        <div className="text-x-sm leading-x-sm">{incomeMessage}</div>
      )}
      {!isLoading && isDeviceOffline ? (
        <DeviceOffline
          currency={currency}
          storagePricePerDay={storagePricePerDay}
        />
      ) : (
        <span className="text-x-sm leading-x-sm">
          {preorderFor
            ? getPreorderMessage(formatDate(preorderFor, DATE_FORMAT_OPTIONS))
            : hostingMessage}
        </span>
      )}
    </div>
  )
}

export default DeviceHostingPrice

const DeviceOffline = ({
  storagePricePerDay,
  currency
}: {
  storagePricePerDay: any
  currency: string
}) => {
  const { locale } = useRouter()

  return (
    <div className="text-x-sm leading-x-sm">
      <FormattedMessage
        {...{
          id: 'device.storage.day',
          defaultMessage: 'Хранение на складе {price} в сутки',
          values: {
            price: formatCurrency(storagePricePerDay, currency, locale)
          }
        }}
      />
    </div>
  )
}
